/**
 * Punto de entrada de la aplicación, es recomendable no intruducir ninguna lógica en este fichero,
 * tales como condicones, bucles, etc. Solo declara llamadas a funciones que se encuentren en otros ficheros para
 * mantener un mejor orden.
 */
import { dictionaryResponse } from './helpers/dictionaryResponse'
import { removeClassDRP } from './helpers/removeClassDRP'


dictionaryResponse()
removeClassDRP()


const version = '1.1.1'
const update = '15/02/2023'
console.log(`Cargada la versión ${version}, actualizada el ${update} 💻`)
